// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"419a5d54","630":"2c2d7efb","827":"6b2cdc2b"}[chunkId] + ".chunk.js";
};